// @core/api/endpoints/form/detach_form.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DetachFormRequest,
  FormLifecycleResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Detach form from entity
 * Detaches the form from an entity with form aspect. Submissions are archived but not deleted. Publishes aspect.detached event.
 */
export async function DetachForm(
  target_type: string,
  target_id: string,
  data: DetachFormRequest,
  options?: RequestOptions
): Promise<FormLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/form/:target_type/:target_id/detach`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<FormLifecycleResponse>(requestPath, data, requestOptions);
}
